import { CopyrightCheckerStatus } from '../interfaces/CopyrightCheckerStatus';
export function getDomainStatus(domain) {
    if (domain.ignored) {
        return CopyrightCheckerStatus.DOMAIN_IGNORED;
    }
    if (!domain.latest_dossier) {
        return CopyrightCheckerStatus.NO_DOSSIER;
    }
    return domain.latest_dossier.status;
}
